import { DqlQuery, Query } from '../field';

export class TaskRecord {

  readonly id: Query.OrderField;
  readonly name: Query.OrderField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.OrderField(prefix + 'id');
    this.name = new DqlQuery.OrderField(prefix + 'name');
  }

}
